import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      fill="none"
      viewBox="0 0 50 50"
      className={className}
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="#fff" fillOpacity="0.5"></circle>
        <circle cx="25" cy="25" r="24.5" stroke="#fff"></circle>
      </g>
      <path
        stroke="#111"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M36 16a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 0116 17s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5 0-.279-.028-.556-.08-.83A7.72 7.72 0 0036 16v0z"
      ></path>
      <defs>
        <filter
          id="filter0_b_50155_60597"
          width="70"
          height="70"
          x="-10"
          y="-10"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImage"
            stdDeviation="5"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_50155_60597"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_50155_60597"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
